export default __webpack_public_path__ + "static/media/e-shopping.86161d08.svg";